"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _AppBarAction = _interopRequireDefault(require("@sprinx/react-mui-layout/AppBarAction"));

var _GlobalSearchField = _interopRequireDefault(require("./GlobalSearchField"));

var _ref2 = /*#__PURE__*/_react.default.createElement(_Search.default, null);

/**
 * Akce aplikacniho toolbaru zobrazujici avatar
 */
function AppBarActionGlobalSearch(_ref) {
  var getSearchResult = _ref.getSearchResult,
      label = _ref.label,
      onChange = _ref.onChange,
      path = _ref.path,
      SearchResultSelector = _ref.SearchResultSelector,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["getSearchResult", "label", "onChange", "path", "SearchResultSelector"]);
  var t = (0, _useTranslate.default)();

  var _ref3 = /*#__PURE__*/_react.default.createElement(_GlobalSearchField.default, {
    path: path,
    getSearchResult: getSearchResult,
    SearchResultSelector: SearchResultSelector,
    onChange: onChange
  });

  return /*#__PURE__*/_react.default.createElement(_AppBarAction.default, (0, _extends2.default)({}, rest, {
    icon: _ref2,
    label: label || t('app/actions/search'),
    path: path,
    renderStandalone: function renderStandalone() {
      return _ref3;
    }
  }));
}

process.env.NODE_ENV !== "production" ? AppBarActionGlobalSearch.propTypes = {
  getSearchResult: _propTypes.default.func.isRequired,

  /**
   * Custom label. Poduk neni poskytnut bude pouzity preklad `app/actions/search`.
   */
  label: _propTypes.default.string,
  onChange: _propTypes.default.func,

  /**
   * Cesta pro presmerovani po kliknuti.
   */
  path: _propTypes.default.string,
  SearchResultSelector: _propTypes.default.elementType.isRequired,

  /**
   * Podminene zobrazeni vysledku.
   *
   * Pokud je hodnota `false`, nebo vysledek volani funkce je `false`,
   * komponenta se nebude zobrazovat.
   *
   * Funkce ma format `(showIfContext) => bool`.
   */
  showIf: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.func]),
  // eslint-disable-line react/no-unused-prop-types

  /**
   * Variant zobrazeni.
   *
   * - `none` nezobrazuje se.
   * - `standalone` aplikuje se renderStandalone pokud je definovano, nebo se renderuje IconButton.
   * - `menuItem` aplikuje se renderMenuItem pokud je definovano, nebo se renderuje MenuItem.
   */
  variant: _propTypes.default.oneOf(['none', 'standalone', 'menuItem'])
} : void 0;
AppBarActionGlobalSearch.defaultProps = {
  label: undefined,
  onChange: undefined,
  path: '/search',
  showIf: true,
  variant: undefined
};
var _default = AppBarActionGlobalSearch;
exports.default = _default;